module.exports = __webpack_public_path__ + "img/1458908352.80e9891c.jpg";